import React from "react";

export const Changelog = () => {
  return (
      <>
        <h3>Changelog</h3>
        <pre>{`
v2.0.0 Google Polyline Algorithm & AWS update (April 2021)
  - Save every street's path as an Encoded Polyline Algorithm Format
    https://developers.google.com/maps/documentation/utilities/polylinealgorithm
  - Refactoring and dockerizing backend
---------
v1.1.0 Adjust OSM highway selection
 - Based on troyml42 idea, we modified the OSM query, more details on GitHub issue:
 https://github.com/matejker/everystreet/issues/3#issuecomment-739417939
---------
v1.0.0 First public release (August 2020)
 - Route generation on neighbourhood given by polygon or Nominatim location
 - Backend powered with OSMnx network on drive layer
 - React web app
        `}</pre>

      </>
  );
}
